// eslint-disable-next-line import/prefer-default-export
export const BidProcessType = Object.freeze({
    Sequential: 0,
    Preferential: 1,
});
